import lodash from "lodash/core";
const countriesData = require("../resources/countries.json");
const inputFields = require("../resources/inputfields.json");

// Wrapper around the inbuilt sort method to perform some additional tasks.
const sortOptions = (options) => {
    let sortedOption = options;
    const allObject = {value: "all", label: "All"};
    // Sort the options in ascending alphabetical order
    sortedOption.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1)
    sortedOption.unshift(allObject);
    return sortedOption;
}

/**
 * @param filterOptions
 * @param dataList
 * @returns A populated filtersOption Object with the DP Names, Countries, and Status
 * computed from the dataList passed as params. Checks if already populated - returns the
 * same object if true, else populates the attributes.
 */
export function populateFilterOptions(filterOptions, dataList) {

    let namesAdded = [];
    let countriesAdded = [];
    let verifiableElementsAdded = [];
    let bgAdded = [];

    if (filterOptions.dpFilterOptions.length === 0 &&
        filterOptions.countryOptions.length === 0 &&
        filterOptions.verifiableElementsOptions.length === 0 &&
        filterOptions.invoiceNameOptions.length === 0 &&
        filterOptions.statusOptions.length === 0) {

        dataList.forEach(service => {

            // test if the provider name has already been added as a filter option, if not - add it
            if (!namesAdded.includes(service.provider_name)) {
                namesAdded.push(service.provider_name);
                filterOptions.dpFilterOptions.push({
                    value: service.provider_name,
                    label: service.provider_name
                });
            }

            // test if the invoice name has already been added as a filter option, if not - add it
            if (service.invoice_name !== null) {
                if (!bgAdded.includes(service.invoice_name)) {
                    bgAdded.push(service.invoice_name);
                    filterOptions.invoiceNameOptions.push({
                        value: service.invoice_name,
                        label: service.invoice_name
                    });
                }
            }

            // test if the country has already been added as a filter option, if not - add it
            // This method is updated to accommodate the string of country codes sent
            // by the API (converted to array at load-time in Redux state)
            if (service.associated_countries !== null) {
                service.associated_countries.forEach(country => {
                    if (!countriesAdded.includes(country)) {
                        // get the country label
                        const countryOption = lodash.find(countriesData, {
                            value: country
                        });
                        countriesAdded.push(country);
                        filterOptions.countryOptions.push({
                            value: countryOption.value,
                            label: countryOption.label
                        });
                    }
                })
            }

            if (service.verifiable_elements !== null) {
                service.verifiable_elements.forEach(element => {
                    if (!verifiableElementsAdded.includes(element)) {
                        // get the country label
                        const elementOption = lodash.find(inputFields, {
                            label_name: element
                        });
                        verifiableElementsAdded.push(element);
                        filterOptions.verifiableElementsOptions.push({
                            value: elementOption.label_name,
                            label: elementOption.label_name
                        });
                    }
                })
            }

        });

        // status feature has been refactored to now only hold value whether a service is
        // integrated or not. Hence, instead of burdening the loop the filter options
        // array has been hard-coded.
        filterOptions.statusOptions = [
            { label: "Integrated", value: 1 },
            { label: "Not Integrated", value: 0 }
        ]

        filterOptions.subDPTypeOptions = [
            { label: "Business Verification", value: "bv" },
            { label: "BV+", value: "bv+" },
            { label: "ODO", value: "odo" },
            { label: "KYB", value: "kyb" },
        ]

        filterOptions.dpFilterOptions = sortOptions(filterOptions.dpFilterOptions);
        filterOptions.statusOptions = sortOptions(filterOptions.statusOptions);
        filterOptions.countryOptions = sortOptions(filterOptions.countryOptions);
        filterOptions.invoiceNameOptions = sortOptions(filterOptions.invoiceNameOptions);
        filterOptions.subDPTypeOptions = sortOptions(filterOptions.subDPTypeOptions);

    }
    return filterOptions;
}


/**
 * @param filterOptions
 * @param dataList
 * @returns A populated filtersOption Object with the Countries and Data Source Types
 * computed from the dataList passed as params. Checks if already populated - returns the
 * same object if true, else populates the attributes.
*/
export function populateTestcacheFilterOptions(filterOptions, dataList) {

    let countriesAdded = [];
    let dataSourcesAdded = [];

    if (filterOptions.testcacheCountryOptions.length === 0 &&
        filterOptions.testcacheDataSourceTypeOptions.length === 0) {

        dataList.forEach(testcache_record => {

            if (!countriesAdded.includes(testcache_record.countrycode)) {
                const country = lodash.find(countriesData, {
                    value: testcache_record.countrycode
                });
                countriesAdded.push(testcache_record.countrycode);
                filterOptions.testcacheCountryOptions.push({
                    value: testcache_record.countrycode,
                    label: country.label
                });
            }

            if (!dataSourcesAdded.includes(testcache_record.data_source_type)) {
                dataSourcesAdded.push(testcache_record.data_source_type);
                filterOptions.testcacheDataSourceTypeOptions.push({
                    value: testcache_record.data_source_type,
                    label: testcache_record.data_source_type
                });
            }

        });

        filterOptions.testcacheCountryOptions = sortOptions(filterOptions.testcacheCountryOptions);
        filterOptions.testcacheDataSourceTypeOptions = sortOptions(filterOptions.testcacheDataSourceTypeOptions);
    }

    return filterOptions;
}

/**
 * @param filterOptions
 * @param dataList
 * @returns A populated filtersOption Object with the Countries and Data Sources
 * computed from the KYB dataList passed as params.
 */
export function populateKYBTestcacheFilterOptions(filterOptions, dataList) {

    let countriesAdded = [];
    let dataSourcesAdded = [];

    if (filterOptions.kybTestcacheCountryOptions.length === 0 &&
        filterOptions.kybTestcacheDataSourceOptions.length === 0) {

        dataList.forEach(kyb_testcache_record => {

            if (kyb_testcache_record.countrycode && !countriesAdded.includes(kyb_testcache_record.countrycode)) {
                const country = lodash.find(countriesData, {
                    value: kyb_testcache_record.countrycode
                });
                countriesAdded.push(kyb_testcache_record.countrycode);
                filterOptions.kybTestcacheCountryOptions.push({
                    value: kyb_testcache_record.countrycode,
                    label: country ? country.label : kyb_testcache_record.countrycode
                });
            }

            if (kyb_testcache_record.datasource && !dataSourcesAdded.includes(kyb_testcache_record.datasource)) {
                dataSourcesAdded.push(kyb_testcache_record.datasource);
                filterOptions.kybTestcacheDataSourceOptions.push({
                    value: kyb_testcache_record.datasource,
                    label: kyb_testcache_record.datasource
                });
            }

        });

        filterOptions.kybTestcacheCountryOptions = sortOptions(filterOptions.kybTestcacheCountryOptions);
        filterOptions.kybTestcacheDataSourceOptions = sortOptions(filterOptions.kybTestcacheDataSourceOptions);
    }

    return filterOptions;
}

